import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bar-chart-sharp",
  "use": "icon-bar-chart-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-bar-chart-sharp\"><title>Bar Chart</title><path d=\"M496 496H16V16h32v448h448v32z\" /><path d=\"M192 432H80V208h112zM336 432H224V160h112zM479.64 432h-112V96h112z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol